import React from 'react'
import MiniHeader from '../MiniHeader'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// import townsend from '../../../assets/img/townsend.png'
// import logos from '../../../assets/img/logos.svg'
// import parkingpayments from '../../../assets/img/parkingpayments.png'
import { getPartnerDetails, getPartnerLogo } from '../../../utils/helper'
import { EMPTY_OBJECT } from '../../../constants/globalConstants'

function AboutUs(props) {
    const {partnerDetails} = props
    const partner = window.location.toString().split('/')[3]
    return (
        <div>
            <MiniHeader isDisplayBack noLoginIcon title='About Us' />
            <div className='text-center'>
                <img
                    className='mt-3 mb-2 text-justify img-res'
                    src={partner ? partnerDetails ? partnerDetails?.brand_setting?.logourl : getPartnerDetails()?.brand_setting?.logourl : getPartnerLogo('parkengage')}
                    alt={partner ? partner : 'Parking'}
                />

                <h4 className='text-secondary mt-3'>{partner == 'parkingpayments' ? 'Parking Payment' : partner == 'townsend' ? 'Townsend' : partner == 'intrapark' ? 'Intrapark' : partnerDetails ? partnerDetails?.company_name : getPartnerDetails()?.company_name ? getPartnerDetails()?.company_name : 'Parkengage'}</h4>

                <a href={partner == 'intrapark' ? 'https://www.intrapark.co/' : partnerDetails ? partnerDetails?.brand_setting?.url ? partnerDetails?.brand_setting?.url : '#' : getPartnerDetails()?.brand_setting?.url ? getPartnerDetails()?.brand_setting?.url : 'https://www.parkengage.com'} className='text-secondary text-decoration-none fs-6' target='_blank' rel="noreferrer">{partner == 'intrapark' ? 'https://www.intrapark.co/' : partnerDetails ? partnerDetails?.brand_setting?.url ? partnerDetails?.brand_setting?.url : partnerDetails?.email : getPartnerDetails()?.brand_setting?.url ? getPartnerDetails()?.brand_setting?.url : 'https://www.parkengage.com'} </a>
            </div>
        </div>
    )
}

AboutUs.propTypes = {
	partnerDetails: PropTypes.object,
}

AboutUs.defaulProps = {
	partnerDetails: EMPTY_OBJECT,
}

function mapStateToProps() {
	return {

	}
}
export default connect(mapStateToProps)(AboutUs)
